






























































































































































































































































































import { EventBus } from "@/event-bus";
import MachinesModal from "@/components/MachinesModal.vue";
import { translateField } from "@/services/checklist.service";

export default {
  props: ["taskLoaded"],
  data() {
    return {
      unsavedInterval: null,
      filter1: null,
      the_question: null,
      org_entry: {},
      org_machines: [],
      username: null,
      field_message_name_en: [],
      field_message_name_fr: [],
      field_message_instruction_en: [],
      field_message_instruction_fr: [],
      field_message_reportText_en: [],
      field_message_reportText_fr: [],
      showMachines: false,
      sel_addmachines: [],
      sel_removemachines: [],
      sel_machinesingroup: [],
      /*
      task_formats: [
        { text: this.$t('LABEL50'), value: "resultFormat/standard" },
        { text: this.$t('LABEL51'), value: "resultFormat/bearing" },
        { text: this.$t('LABEL52'), value: "resultFormat/bladeDamageHKS" },
        { text: this.$t('LABEL53'), value: "resultFormat/flanges" },
        { text: this.$t('LABEL54'), value: "resultFormat/flangeBolting" },
        {
          text: this.$t('LABEL55'),
          value: "resultFormat/foundationCracksConcreteBody",
        },
        {
          text: this.$t('LABEL56'),
          value: "resultFormat/lighningProtectionRotorBlades",
        },
        {
          text: this.$t('LABEL57'),
          value: "resultFormat/rotorblattschadenCK",
        },
        { text: this.$t('LABEL58'), value: "resultFormat/textarea" },
        { text: this.$t('LABEL59'), value: "resultFormat/toothing" },
      ],
      */
    };
  },
  watch: {
    taskLoaded: function (val, oldVal) {
      this.the_question = null;
    },
  },
  components: {
    MachinesModal,
  },
  computed: {
    task_formats: function () {
      let tk = []
      for (let k of this.$store.state.cl_message_formats) {
        console.log(k)
        tk.push({ text: k.name, value: k.format_id });
      }
      return tk
    },
    appLang: function() {
      return this.$store.state.lang
    },
    onlyPV: function () {
      return   this.$store.getters.userRole.db_region //this.userRole.db_region == 'eso'
    },
    copy_entry() {
      return (
        this.$store.state.copy_entry &&
        this.$store.state.copy_entry.type == "question"
      );
    },
    copy_entry_name() {
      return this.$store.state.copy_entry && this.$store.state.copy_entry.name;
    },
    lblQuestions() {
      return this.$t('CHECKPOINTS')+" (" + this.questions.length + ")";
    },
    entry() {
      if (this.$store.state.cl_task) {
        if (!this.$store.state.cl_task.machinegroup_list) {
          this.$store.state.cl_task.machinegroup_list = [];
        }

        if (this.$store.state.cl_task.machinegroup) {
          if (!this.$store.state.cl_task.machinegroup_created) {
            this.$store.state.cl_task.machinegroup_created = true;
            this.$store.state.cl_task.machinegroup_list = [
              this.$store.state.cl_task.machinegroup,
            ];
          }
        }

        this.$store.state.cl_component.machinegroup_created = true;

        return this.$store.state.cl_task;
      }
      return {};
    },
    questions() {
      return this.$store.state.cl_question_list;
    },
    machinegroups() {
      return this.$store.state.cl_machine_groups;
    },
    projects() {
      return this.$store.state.projects;
    },
    saving() {
      return (
        this.$store.state.saving && this.$store.state.saving_type == "task"
      );
    },
    machines() {
      if (this.filter1 && this.filter1.length > 0) {
        return this.$store.state.machines.filter((machine) => {
          return (
            machine.text.toLowerCase().indexOf(this.filter1.toLowerCase()) !==
            -1
          );
        });
      }
      return this.$store.state.machines;
    },
  },
  mounted() {
    EventBus.$on("task_changed", this.taskChangedHandler);
    EventBus.$on("question_closed", this.questionClosedHandler);
    EventBus.$on("entry_added", this.addedHandler);
    EventBus.$on("updateInformElement", this.updateInformElement);
    this.updateUsername();
  },
  destroyed() {
    EventBus.$off("task_changed", this.taskChangedHandler);
    EventBus.$off("entry_added", this.addedHandler);
    EventBus.$off("question_closed", this.questionClosedHandler);
    EventBus.$off("updateInformElement", this.updateInformElement);
  },
  methods: {
    updateInformElement: function (d) {
      if (d.type != "task" && d.uid != this.entry.uid) {
        this.save();
        console.log("TASK speichern");
      }
    },
    updateUsername: function () {
      if (this.entry.user_uid) {
        this.username = this.$store.state.users[this.entry.user_uid];
      } else {
        this.username = "";
      }
    },
    selQuestion: function () {
      this.$emit("selectQuestion", this.the_question);
    },
    save() {
      //this.loading = true;

      let check1 = { ...this.org_entry };
      let check2 = { ...this.entry };
      delete check1.created_at;
      delete check2.created_at;
      delete check1.user_uid;
      delete check2.user_uid;
      delete check1.type;
      delete check2.type;

      this.entry.type = "task";

      if (
        JSON.stringify(check1) != JSON.stringify(check2) ||
        this.entry.machines.length != this.org_machines.length
      ) {
        this.entry.user_uid = this.$store.state.userId;
        this.entry.created_at = Date.now();
        this.org_entry = { ...this.entry };
        this.updateUsername();
        this.$emit("updateAct", this.entry);
        EventBus.$emit("updateInformElement", {
          type: "task",
          uid: this.entry.uid,
        });
      } else {
        this.$emit("updateAct", { no_changes: true });
      }
    },
    createAct: function (type) {
      this.$emit("createAct", { type: type });
    },
    sortAct: function (type) {
      this.$emit("sortAct", { type: type });
    },
    deleteAct: function (type) {
      this.entry.type = type;
      this.$emit("deleteAct", this.entry);
    },
    copyAct: function (type) {
      this.entry.type = type;
      this.$emit("copyAct", {
        type: type,
        cl_uid: this.entry.cl_uid,
        uid: this.entry.uid,
        name: this.entry.name,
      });
    },
    close: function () {
      EventBus.$emit("task_closed", this.entry);
    },
    pasteEntry: function () {
      this.$emit("pasteAct");
    },
    addedHandler: function (data) {
      if (data.type == "question") {
        this.the_question = data.entry_uid;
        this.selQuestion();
      }
    },
    questionClosedHandler: function (data) {
      this.the_question = null;
    },
    taskChangedHandler: function (data) {
      this.org_entry = { ...this.entry };
      this.org_machines = JSON.parse(JSON.stringify(this.entry.machines));
      this.updateUsername();

      // Deeplink auf den Prüfpunkt
      if (
        this.$store.state.initParams.question &&
        this.$store.state.initParams.question.length > 2 &&
        this.questions.filter(
          (item) => item.value == this.$store.state.initParams.question
        ).length > 0
      ) {
        this.$emit("selectQuestion", this.$store.state.initParams.question);
      }
      // Prüfpunkt wählen, wenn es nur einen gibt
      else if (this.questions.length == 1) {
        this.$emit("selectQuestion", this.questions[0].value);
      }
    },
    dialogClosed: function (val) {
      this.showMachines = false;
    },
    changeMachines: function (val) {
      this.showMachines = false;
      // {add_machines: this.add_machines, remove_machines: this.remove_machines}
      this.entry.machines = val.add_machines;
      this.entry.remove_machines = val.remove_machines;

      if (val.group_uid) {
        // Es wurde eine neue Gruppe aus der Auswahl erstellt
        this.entry.machinegroup_list = [val.group_uid];
      }
    },
    openMachinesDialog: function () {
      this.sel_addmachines = JSON.parse(JSON.stringify(this.entry.machines));
      this.sel_removemachines = JSON.parse(
        JSON.stringify(this.entry.remove_machines)
      );
      this.showMachines = true;

      this.sel_machinesingroup = [];

      if (this.machinegroups) {
        for (let k of this.machinegroups) {
          if (this.entry.machinegroup_list) {
            for (let m of this.entry.machinegroup_list) {
              if (k.value == m) {
                this.sel_machinesingroup = this.sel_machinesingroup.concat(
                  JSON.parse(JSON.stringify(k.machines))
                );
              }
            }
          } else {
            if (k.value == this.entry.machinegroup) {
              this.sel_machinesingroup = JSON.parse(JSON.stringify(k.machines));
              break;
            }
          }
        }
      }
    },
    appendIconCallback: function (v1, v2) {
      if (this.entry[v2] && this.entry[v2].length > 2) {
        this["field_message_" + v1] = ["übersetze..."];
        translateField(this.entry[v2]).then((data) => {
          this["field_message_" + v1] = [];
          if (data.status == "success") {
            this.entry[v1] = data.translations[0].text;
            this.$forceUpdate();
          }
        });
      }
    },
  },
};
